export const USER_LANGUAGE_COOKIE = 'userLanguage';

export const PRODUCT_ID_COOKIE = 'productID';

export const LOGGED_IN_COOKIE = 'loggedIn';

export const LOGGED_IN_COOKIE_CLIENT_SIDE = 'loggedIn_osmosis_client';

export const UUID_COOKIE = 'uuid';

export const TRACKING_USER_OBJECT_COOKIE = 'tracking.userObject';

export const COUNTRY_COOKIE = 'country';

export const CONNECT_SID_COOKIE = 'connect.sid';

export const COLOR_SCHEME_COOKIE = 'colorScheme';

export const VISITED_PAGE_COOKIE = 'visitedPage';

export const FEATURE_FLAG_COOKIE_NAME = 'feature-flags-next';

export const DEVICE_FINGERPRINT_COOKIE = 'deviceFingerprint';

export const NEOID_STATE_COOKIE = 'neoIDState';

export const SALE_BANNER_ALREADY_SEEN = 'sale-banner-already-seen';

export const GTM_PURCHASE_EVENT_COOKIE = 'gtm_purchase_event';

export const GUEST_CHECKOUT_USER_COOKIE = 'guestCheckoutUser';

export const CME_MODAL_DESCRIPTION_KEY_COOKIE = 'cme:hide_description';

export const CURRENCY_COOKIE = 'currency';

export const FILL_PROFILE_REMINDER_COOKIE = 'fill-profile-reminder';

export const EOLS_LTI_COOKIE = 'eols-token';

export const EOLS_LTI_REFRESH_COOKIE = 'eols-refresh-token';
